// [목적] 강원캔버스 모션 토큰 (design_structure §3-5)
// [이유] CLAUDE.md §6-3 — 트랜지션 duration/easing 직접 입력 금지
// [사이드 이팩트] MUI 테마 transitions / 모든 호버·페이지전환·인트로 애니메이션
// [수정 시 고려사항] 접근성 prefers-reduced-motion 사용자에게는 지속시간 0 처리 필요 (별도 hook에서)

export const motion = {
  fast: { duration: 120, easing: 'cubic-bezier(0, 0, 0.2, 1)' }, // ease-out
  med: { duration: 220, easing: 'cubic-bezier(0, 0, 0.2, 1)' }, // ease-out
  slow: { duration: 360, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }, // 폴리오 표지 인트로
} as const;

export type MotionTokens = typeof motion;
export type MotionKey = keyof typeof motion;
